import { render, staticRenderFns } from "./ConversationActionsShortcut.vue?vue&type=template&id=e0669596&scoped=true"
import script from "./ConversationActionsShortcut.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConversationActionsShortcut.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ConversationActionsShortcut.vue?vue&type=style&index=0&id=e0669596&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0669596",
  null
  
)

export default component.exports